import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { Navigate } from 'react-router-dom';

const PrivateLandlordEsignRoute = ({ redirectPath = '/login', children }) => {
  const location = useLocation();

  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const isLandlord = useSelector((state) => state.auth.currentUser.isLandlord);
  const isEsignReady = useSelector((state) => state.landlordApplication.isEsignReady);

  if (!(isLoggedIn && isLandlord && isEsignReady)) return <Navigate to={redirectPath} replace from={{ from: location }}/>;
  return children;
};

PrivateLandlordEsignRoute.propTypes = {
  redirectPath: PropTypes.string,
  children: PropTypes.element,
};

export default PrivateLandlordEsignRoute;
